import RestClient from '../Client/RestClient'
import Configuration from '../Api/Configuration'

let { Admin_EndPoints } = Configuration

class EntityServices {
    static getLateSubmissionRemainingQuota(defaultErrorMessage = '') {
        return RestClient.getRequest(Admin_EndPoints.getLateSubmissionRemainingQuota, null, defaultErrorMessage)
    }

    static getLateSubmissionData(params, defaultErrorMessage = '') {
        let config = {}
        if (!!params && !!Object.keys(params).length) {
            config['params'] = params
        }
        return RestClient.getRequest(Admin_EndPoints.getLateSubmissionDetails, config, defaultErrorMessage, true)
    }
}
export default EntityServices